var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.666,
    height: 80.666,
    viewBox: "0 0 80.666 80.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M50,9.667A40.333,40.333,0,1,0,90.333,50,40.379,40.379,0,0,0,50,9.667Zm3.648,65.14V83.07H45.705v-7.7c-5.433-.244-10.7-1.7-13.782-3.484L34.355,62.4a28.65,28.65,0,0,0,13.455,3.564c4.62,0,7.781-1.781,7.781-5.021,0-3.084-2.594-5.031-8.59-7.057-8.677-2.916-14.594-6.969-14.594-14.83,0-7.135,5.026-12.727,13.7-14.43v-7.7h7.943v7.135a29.274,29.274,0,0,1,11.756,2.672L63.456,35.9a26.9,26.9,0,0,0-11.673-2.76c-5.271,0-6.973,2.271-6.973,4.541,0,2.674,2.838,4.377,9.729,6.971,9.646,3.406,13.537,7.861,13.537,15.16C68.077,67.025,62.968,73.184,53.648,74.807Z",
    transform: "translate(-9.667 -9.667)",
    fill: "#375644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.a32faafa68eeb5a21be7c32f98787477.svg";
export { ForwardRef as ReactComponent };